import * as React from "react";
import type { SVGProps } from "react";
const SvgStrategyhistoryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="strategyhistory_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M554.667 729.6a153.6 153.6 0 1 1 307.2 0 153.6 153.6 0 0 1-307.2 0zm153.6-230.4a230.4 230.4 0 1 0 0 460.8 230.4 230.4 0 0 0 0-460.8zm28.8 172.8a38.4 38.4 0 1 0-76.8 0v76.8c0 12.8 6.4 24.832 17.066 31.957l57.6 38.4a38.4 38.4 0 1 0 42.667-63.914l-40.533-27.008V672zM85.333 256A170.667 170.667 0 0 1 256 85.333h426.667A170.667 170.667 0 0 1 853.333 256v128A42.667 42.667 0 1 1 768 384V256a85.333 85.333 0 0 0-85.333-85.333H256A85.333 85.333 0 0 0 170.667 256v512A85.333 85.333 0 0 0 256 853.333h128a42.667 42.667 0 1 1 0 85.334H256A170.667 170.667 0 0 1 85.333 768V256zm587.435 112.64a42.667 42.667 0 1 0-65.536-54.613l-79.019 94.72-116.48-99.84a42.667 42.667 0 0 0-60.586 5.12l-106.667 128a42.667 42.667 0 0 0 65.579 54.613l79.061-94.72 116.48 99.84a42.667 42.667 0 0 0 60.587-5.12l106.666-128z"
    />
  </svg>
);
export default SvgStrategyhistoryIcon;
